<template>
  <span
    :class="`currency-flag currency-flag-${(currencyCode || '').toLowerCase()}`"
  />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import "currency-flags/dist/currency-flags.min.css";

export default defineComponent({
  name: "CurrencyFlag",
  props: {
    currencyCode: { type: String, required: true }
  }
});
</script>

<style lang="scss" scoped>
.currency-flag {
  margin-bottom: -2px;
}
</style>
